import memoize from "lodash/memoize"
import omit from "lodash/omit"
import { Model, Schema } from "src/engine/modules/model/classes"

export default memoize(
  rtid =>
    new Model({
      name: `resourceTypeCustomField`,
      uin: Math.random(),
      rtid,
      getRestUrn: (method, id) => {
        switch (method) {
          case `post`:
            return `/resources/types/${rtid}/fields`
          case `get`:
            return id
              ? `/resources/types/fields/${id}`
              : `/resources/types/${rtid}/fields`
          case `put`:
          case `delete`:
            return `/resources/types/fields/${id}`
          default: {
            throw new Error(`Unsupported REST method ${method}`)
          }
        }
      },
      denormalize: data =>
        omit({ ...data, required: Boolean(data.required) }, [`id`]),
      schema: new Schema({}),
    }),
)
